export default "__VITE_ASSET__a0fcb3b6__"